import axios from 'axios';
import LocalStorageService from '../services/localStorage';
const localStorageService = LocalStorageService.getService();
const openSnackbar = (msg) => {
  // Get the snackbar DIV
  let x = document.querySelector('#snackbar');
  x.innerHTML = msg;
  // Add the "show" class to DIV
  x.className = 'show';
  // After 3 seconds, remove the show class from DIV
  setTimeout(function () {
    x.className = x.className.replace('show', '');
  }, 3000);
};

// TODO temporary changes, unless login api is done
const headers = {
  'Content-type': 'application/json; charset=utf-8',
  'Cache-Control': `no-cache`,
  Authorization: `Bearer ${localStorageService.getAccessToken()}`,
};
const baseUrl = process.env.REACT_APP_API_URL;
const API = axios.create({
  baseURL: baseUrl,
  headers,
});

const toggleIndicator = (url, type) => {
  if (url && url.includes('pacheck-portal/branding')) {
    const loader = document.querySelector('.showLoader');
    if (loader) loader.style.display = type ? 'flex' : 'none';
  }
};

API.interceptors.request.use(
  (config) => {
    toggleIndicator(config.url, true);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const expireSession = () => {
  LocalStorageService.clearToken();
  setTimeout(function () {
    window.location = '/pingfedit/ssologin';
  }, 1000);
}
const logout = () => {
  axios.post(`${baseUrl}/users/logout`, {
    "token": localStorage.getItem('refreshToken'),
    "client_id": localStorage.getItem('clientID')
  })
  .then((res) => {
    expireSession();
  });
}

API.interceptors.response.use(
  (response) => {
    toggleIndicator(response.config.url, false);
    return response;
  },
  async function (error) {
    if (error && error.config && error.config.url) {
      toggleIndicator(error.config.url, false);
    }
    if (error && error.response === undefined) {
      openSnackbar("Error: Network Error");
    } else if (
      error &&
      error.response &&
      error.response.status &&
      (error.response.status === 415 || error.response.status === 416)
    ) {
      openSnackbar(JSON.stringify(error.response.data.error));
    } else if (
      error &&
      error.response &&
      error.response.status &&
      (error.response.status === 411 || error.response.status === 417)
    ) {
      window.location = '/not-found';
    }
    const originalRequest = error.config;
    let timeOutValue = 200;
    if (error.response.status === 403) {
      if (
        error.response.data.error_type !== 'login_failed' &&
        !error.response.data.error.includes('suspended')
      ) {
        await axios
          .post(`${baseUrl}/users/generate-token`, {
            refreshToken: localStorage.getItem('refreshToken'),
            client_id: localStorage.getItem('clientID'),
            app: "providers",
          })
          .then((res) => {
            if (
              (res?.data?.data?.error &&
                res.data.data.error.toUpperCase().replace(/[ _]/g, '-') ===
                  'NOTAUTHORIZEDEXCEPTION:-INVALID-REFRESH-TOKEN') ||
              (res?.data?.data?.error &&
                res.data.data.error.toUpperCase().replace(/[ _]/g, '-') ===
                  'NOTAUTHORIZEDEXCEPTION:-REFRESH-TOKEN-HAS-EXPIRED')
            ) {
              openSnackbar(res.data.data.error);
              logout();
            } else {
              if (res.data.data.AuthenticationResult?.AccessToken) {
                localStorage.setItem(
                  'accessToken',
                  res.data.data.AuthenticationResult.AccessToken,
                );
                if (error.response.config.url === 'users/me') {
                  window.location = '/';
                }
              }
            }
          })
          .catch((err) => {
            openSnackbar(error?.response?.data?.error);
            expireSession();
          });
        originalRequest._retry = true;
        originalRequest.headers['Authorization'] =
          // eslint-disable-next-line no-useless-concat
          'Bearer ' + `${localStorage.getItem('accessToken')}`;

        return axios(originalRequest);
      } else if (error.response.data.error_type === 'unauthorized_access') {
        if (error.response.data.error.includes('suspended')) {
          openSnackbar('Your account has been suspended');
        }
      }
      LocalStorageService.clearToken();
      setTimeout(() => {
        window.location = '/login';
      }, timeOutValue);
    }

    return Promise.reject(error);
  },
);

export default API;
